import 'dayjs/locale/sl'
import { Dayjs } from 'dayjs'

const sl = {
  calendar: {
    sameDay: '[danes ob] LT',
    nextDay: '[jutri ob] LT',

    nextWeek: function (now: Dayjs) {
      switch (now.day()) {
        case 0:
          return now.format('[v] [nedeljo] [ob] LT')
        case 3:
          return now.format('[v] [sredo] [ob] LT')
        case 6:
          return now.format('[v] [soboto] [ob] LT')
        case 1:
        case 2:
        case 4:
        case 5:
          return now.format('[v] dddd [ob] LT')
      }
    },
    lastDay: '[včeraj ob] LT',
    lastWeek: function (now: Dayjs) {
      switch (now.day()) {
        case 0:
          return now.format('[prejšnjo] [nedeljo] [ob] LT')
        case 3:
          return now.format('[prejšnjo] [sredo] [ob] LT')
        case 6:
          return now.format('[prejšnjo] [soboto] [ob] LT')
        case 1:
        case 2:
        case 4:
        case 5:
          return now.format('[prejšnji] dddd [ob] LT')
      }
    },
    sameElse: 'L'
  }
}

export default sl
